/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Table_NameInputs */

const en_work_order_publish_table_name = /** @type {(inputs: Work_Order_Publish_Table_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const fr_work_order_publish_table_name = /** @type {(inputs: Work_Order_Publish_Table_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const de_work_order_publish_table_name = /** @type {(inputs: Work_Order_Publish_Table_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const it_work_order_publish_table_name = /** @type {(inputs: Work_Order_Publish_Table_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const ru_work_order_publish_table_name = /** @type {(inputs: Work_Order_Publish_Table_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя`)
};

const es_work_order_publish_table_name = /** @type {(inputs: Work_Order_Publish_Table_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const zh_cn2_work_order_publish_table_name = /** @type {(inputs: Work_Order_Publish_Table_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const ja_work_order_publish_table_name = /** @type {(inputs: Work_Order_Publish_Table_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

const hi_work_order_publish_table_name = /** @type {(inputs: Work_Order_Publish_Table_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम`)
};

const pt_pt2_work_order_publish_table_name = /** @type {(inputs: Work_Order_Publish_Table_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Work_Order_Publish_Table_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_table_name = /** @type {((inputs?: Work_Order_Publish_Table_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Table_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_table_name(inputs)
	if (locale === "de") return de_work_order_publish_table_name(inputs)
	if (locale === "it") return it_work_order_publish_table_name(inputs)
	if (locale === "ru") return ru_work_order_publish_table_name(inputs)
	if (locale === "es") return es_work_order_publish_table_name(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_table_name(inputs)
	if (locale === "ja") return ja_work_order_publish_table_name(inputs)
	if (locale === "hi") return hi_work_order_publish_table_name(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_table_name(inputs)
	return en_work_order_publish_table_name(inputs)
});